import React, { Component } from 'react'
import { Col,  FormGroup, FormControl } from "react-bootstrap"
import { PropTypes } from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { states } from '../../../utils/constants';


class Location extends Component {
    static propTypes = {
			locationChange: PropTypes.func,
			year: PropTypes.number,
    }
    constructor(props,context) {
			super(props,context)
			this.state = {
					city:'',
					state:'-1',
					date: this.setDefaultDate(),
			}
			this.handleValueChange = this.handleValueChange.bind(this)
			this.handleCityChange  = this.handleCityChange.bind(this)
			this.handleStateChange = this.handleStateChange.bind(this)
			this.populateStates    = this.populateStates.bind(this)
			this.handleDateChange = this.handleDateChange.bind(this)
			this.setDefaultDate = this.setDefaultDate.bind(this)
    }
    componentDidUpdate() {

    }
    setDefaultDate() {
			const year = this.props.year;
			let defaultDate = moment(`07/19/${year}`);
			const dayOfWeek = defaultDate.day();
			const addDays = dayOfWeek === 6 ? 0: -(dayOfWeek + 1);
			defaultDate = defaultDate.add('days', addDays);
			return defaultDate;
		}
    handleValueChange(){
      
		}
		handleDateChange(date) {		
			const { state }  = this.state;
			this.setState({ date });
			this.props.locationChange(date, state, date);
		}
    handleCityChange(evt) {
      const city = evt.target.value;
      const { state,date }  = this.state;
      this.setState({ city });
      this.props.locationChange(city, state, date);
    }
    handleStateChange(evt) {
			const state = evt.target.value;
			const { city, date }  = this.state;
			this.setState({ state });
			this.props.locationChange(city, state, date);
    }
    populateStates()
    {
			const option = states.map((state)=> {
				return (<option value={state.abbreviation} key={state.abbreviation}>{ state.name }</option>)
			});
			return option;
    }
    render() {
			return (
        <div>
					<FormGroup>
						<label className="col-lg-3 control-label">Tournament Date<span style={{ color: 'red', padding:'3px' }}>*</span></label>
						<Col lg={ 6 }>
						<DatePicker
							selected={this.state.date}
							onChange={this.handleDateChange}
							placeholderText="mm/dd/yyyy"
							dateFormat="MM/DD/YYYY"	
							className="form-control"
							id="date"
							maxDate={moment().add(2, 'years')}
						/>
						</Col>
					</FormGroup>
					<FormGroup>
						<label className="col-lg-3 control-label">Tournament City<span style={{ color: 'red', padding:'3px' }}>*</span></label>
						<Col lg={ 6 }>
						<FormControl type="email" placeholder="Type city" className="form-control" onChange={this.handleCityChange} />
						</Col>
					</FormGroup>
					<FormGroup>
						<label className="col-lg-3 control-label">Tournament State <span style={{ color: 'red' }}>*</span></label>
						<Col lg={ 6 }>
						<select className="form-control" onChange={this.handleStateChange} >
						<option value='-1'>Select a State...</option>
						{ this.populateStates() }
						</select>
						</Col>
					</FormGroup>
      </div>)
    }
}
export default Location;




// WEBPACK FOOTER //
// ./src/containers/season/components/Location.js